module.exports = __webpack_public_path__ + "img/sad.9d5d4908.gif";